import { Fragment, ReactNode, useId } from 'react';

import Tooltip from '@components/tooltip/Tooltip';
import { Tag } from 'types/lead-management';

import ReadOnlyTagChip from './ReadOnlyTagChip';

interface TagOverflowChipProps {
  /** Tags not shown inline; listed in the tooltip. */
  tags: Tag[];
  /** Custom chip per tag (e.g. with a remove icon); the tooltip then stays open on hover. */
  renderTag?: (tag: Tag) => ReactNode;
}

/** "+N" chip with a white tooltip listing the tags that didn't fit. */
const TagOverflowChip = ({ tags, renderTag }: TagOverflowChipProps) => {
  const tooltipId = `tag-overflow-${useId().replace(/:/g, '')}`;

  if (tags.length === 0) return null;

  return (
    <>
      <span
        data-tooltip-id={tooltipId}
        className="cursor-default !rounded-xl bg-grey30 px-2 py-1 text-xs text-darkGrey"
      >
        +{tags.length}
      </span>
      <Tooltip
        id={tooltipId}
        type="custom"
        place="top"
        positionStrategy="fixed"
        clickable={!!renderTag}
        className="!z-[60] !border !border-grey30 !bg-theme !p-2 !text-cofeeNeutral10 !shadow-lg"
      >
        <div className="flex max-w-105 flex-wrap items-center gap-1">
          {tags.map((tag) =>
            renderTag ? (
              <Fragment key={tag.id}>{renderTag(tag)}</Fragment>
            ) : (
              <ReadOnlyTagChip key={tag.id} tag={tag} />
            )
          )}
        </div>
      </Tooltip>
    </>
  );
};

export default TagOverflowChip;
